import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Server, Lock, CheckCircle, Award, Database } from 'lucide-react';

const badges = [
  {
    title: 'ISO 27001 Certified',
    description: 'Information Security Management standard compliant.',
    icon: ShieldCheck,
  },
  {
    title: '99.99% Uptime SLA',
    description: 'Guaranteed enterprise-grade reliability and performance.',
    icon: Server,
  },
  {
    title: 'SOC 2 Type II',
    description: 'Audited for security, availability, and confidentiality.',
    icon: Lock,
  },
  {
    title: 'AWS Advanced Partner',
    description: 'Recognized expertise in cloud infrastructure.',
    icon: Award,
  },
  {
    title: 'GDPR & HIPAA',
    description: 'Strict adherence to global data privacy laws.',
    icon: Database,
  },
  {
    title: '100% Quality Assurance',
    description: 'Rigorous testing protocols for every release.',
    icon: CheckCircle,
  }
];

const TrustBadges = () => {
  return (
    <section className="py-24 bg-slate-50 relative overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 rounded-full bg-blue-100 text-blue-700 font-semibold text-sm mb-4">
            Security & Compliance
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6">
            Enterprise-Grade <span className="text-blue-600">Trust</span>
          </h2>
          <p className="text-lg text-slate-600">
            We adhere to the highest industry standards to ensure your data, infrastructure, and applications are secure, compliant, and always available.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {badges.map((badge, idx) => {
            const Icon = badge.icon;
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
                className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 hover:shadow-md hover:border-blue-200 transition-all group"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors shrink-0">
                    <Icon size={24} />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-slate-900 mb-1">{badge.title}</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">{badge.description}</p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
